import React, { useState, useEffect, useCallback } from 'react';
import { Spin } from 'antd';
import { ListDocuments } from '../listDocuments';
import { useCookies } from 'react-cookie';
import { Dropbox } from 'dropbox';
import DPLOGOIMAGE from '../assets/images/dp-logo.png';
import '@fontsource/noto-sans';
import 'antd/dist/reset.css';
import './App.css';
import { ISelectSourcePopupProps } from './selectSourcePopup.types';

const dropbox_url = `${document.location.protocol}//${document.location.host}/`;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID

export const SelectSourcePopup = (props: ISelectSourcePopupProps) => {

  const { getDropboxFileData } = props;
 
  const [cookies, setCookie, removeCookie] = useCookies();
  const [listDocumentsVisible, setListDocumentsVisibility] = useState(false);
  const [rootId, setRootId] = useState('');
  const [isLoadingGoogleDriveApi, setIsLoadingGoogleDriveApi] = useState(false);
  const [signedInUser, setSignedInUser] = useState(false);
  const [accountId, setAccountId] = useState({});
  const [accessToken, setAccessToken] = useState('');
  const [windowState, setWindowState] = useState(true);
  const [newWindow, setNewWindow] = useState(null);

  /**
   *  Sign out the user upon button click.
   */
  const handleSignOutClick = () => {
    removeCookie('dUser');
    setAccessToken('');
    setAccountId({})
    window.localStorage.removeItem('dUser')
    window.location.assign(dropbox_url);
    //@ts-ignore
    setSignedInUser();
  };

  const getJsonFromUrl = (str : any) => {
    try {
      const query = str.substr(1);
      const result = {};
  
      query.split('&').forEach((part : any) => {
        const item = part.split('=');
        //@ts-ignore
        result[item[0]] = decodeURIComponent(item[1]);
      });
  
      return result; 
    } catch (error) {
      console.warn(error)
    }
  };

  async function getUrl(){
    const dbx: any = new Dropbox({ clientId: CLIENT_ID });
    const authLink: any = await dbx.auth.getAuthenticationUrl(dropbox_url);
    //@ts-ignore
    const childWindow: any = window.open(authLink, 'DropboxAuthPopup','width=' + (parseInt(window.innerWidth) * 0.9) + ',height=' + (parseInt(window.innerHeight) * 0.9)+ ', dialog=yes,dependent=yes,scrollbars=yes,location=yes');

    
    setNewWindow(childWindow);
    setInterval(async () => {
       
        await setLocalStorage(childWindow);
      }, 1000)
  }

  function setLocalStorage(childWindow: Window){
    try {
      childWindow?.localStorage.setItem('dUser', childWindow?.location.hash);
      getTokenAndId(childWindow)  
    } catch (error) {
      window.onerror = function(){
        return true
      }
    }
  }

  function closeChildWindow(childWindow: Window){
   
    childWindow.close()
  }

  useEffect(() => {
    setInterval(() => {
      try {
        //@ts-ignore
      if(newWindow.location.href.includes('access_token')){
        //@ts-ignore
        newWindow?.close()
      }else{
        //@ts-ignore
        newWindow.open()
      }
      } catch (error) {
        // console.warn(error)
        window.onerror = function(){
          return true;
        }
      }
    },5000)
  }, [newWindow, windowState])

  function getTokenAndId(childWindow: Window){
    if (!accessToken) {
      const result: any = getJsonFromUrl(localStorage.getItem('dUser'));
     
      if (!result.access_token) {
        return;
      }
     
      setAccessToken(result.access_token);
      
      setAccountId(result.account_id);
     
      document.cookie = `dUser=${result.access_token}`;
      //@ts-ignore
      setSignedInUser(true);
      setWindowState(false);
      closeChildWindow(childWindow)
    }
  }

  const setAccessTokenOnReload = () => {
    try {
      const result: any = getJsonFromUrl(localStorage.getItem('dUser'));
      setAccessToken(result.access_token); 
      setAccountId(result.account_id);
      document.cookie = `dUser=${result.access_token}`;
      setSignedInUser(true); 
    } catch (error) {
      console.warn(error)
    }
  }

  useEffect(() => {
    window.addEventListener('load', setAccessTokenOnReload)
  })

  const onClose = () => {
    setListDocumentsVisibility(false);
  };

  const signInUpdate = useCallback(() => {
    //@ts-ignore
    setSignedInUser(true);
  }, [signedInUser]);

  const handleClientLoad = () => {
      getUrl();
  }

  return (
    <div className='google-drive-plugin'>
      {signedInUser ? (
        <ListDocuments
          rootId={rootId}
          token={accessToken}
          onSignOut={handleSignOutClick}
          signInUpdate={signInUpdate}
          getDropboxFileData={getDropboxFileData}
        />
      ) : (
        <div>
          <Spin spinning={isLoadingGoogleDriveApi} style={{ width: '100%' }}>
            <div className="source-container" style={{ paddingTop: '35%' }}>
              <div className="content-container">
                <span className="content, get-started">Get started by connecting your account</span>
              </div>
              <div className="icon-container" style={{ paddingTop: '40px' }}>
                <div className="icon icon-success">
                  <img height="148" width="224" src={DPLOGOIMAGE} />
                </div>
              </div>
              <div className={'content-container'} style={{ paddingTop: '50px' }} onClick={() => handleClientLoad()}>
                  <button className={'connect-button'}>Connect</button>
              </div>
            </div>
          </Spin>
        </div>
      )}
    </div>
  );
};